import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// context
import { DataHubAPIContext } from 'containers/DataHub/layers/API'
// icons
import LockIconOrigin from '@mui/icons-material/LockOutlined'
// hooks
import { useCompanySubscriptionLevel, useCurrentUser } from 'hooks/index'
// types
import { CompanySubscriptionLevel } from 'types/graphql'

const ICON_STYLE = {
  marginLeft: '8px'
}

const CreateReportButton: React.FC = () => {
  const { standardReports } = React.useContext(DataHubAPIContext)

  const {
    permissionsFromSecurityGroups: { reportingCreate }
  } = useCurrentUser()

  const router = useRouter()

  const companySubscriptionLevel = useCompanySubscriptionLevel()

  const canCreate = companySubscriptionLevel === CompanySubscriptionLevel.Enterprise && reportingCreate

  const createReport = () => {
    router.push({
      pathname: `/data-hub/report/new/dataset/${standardReports[0].datasetId}/workspace/${standardReports[0].workspaceId}`
    })
  }

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} disabled={!canCreate} onClick={createReport}>
      Create Report {!canCreate && <LockIconOrigin style={ICON_STYLE} />}
    </Button>
  )
}

export default CreateReportButton
